
/// <amd-module name="Release/Helpers/ReleaseEnvironment" />

import { Release, ApprovalStatus, DeploymentStatus } from "Release/Client/Contracts/Release";

export function getEnvironmentNamesInProgress(release: Release): string[] {
    let environmentNames: string[] = [];
    if (release && release.environments) {
        release.environments.forEach((env) => {
            if (env.preDeployApprovals && env.preDeployApprovals.some((appr) => appr.status === ApprovalStatus.Pending)) {
                environmentNames.push(env.name);
            }
            else if (env.deploySteps && env.deploySteps.some((step) => step.status === DeploymentStatus.InProgress)) {
                environmentNames.push(env.name);
            }
        });
    }

    return environmentNames;
}